// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file external/v1/model.proto (package external.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Decimal } from "../../google/type/decimal_pb";
import { file_google_type_decimal } from "../../google/type/decimal_pb";
import type { AreaCode } from "../../types/v1/area_pb";
import { file_types_v1_area } from "../../types/v1/area_pb";
import type { DealPosition, DealSubmissionSource, DeliveryHourType, DeliveryPeriodType, DeliveryType, ProductSpreadType, SpreadType } from "../../types/v1/deal_pb";
import { file_types_v1_deal } from "../../types/v1/deal_pb";
import type { EClearPostingStatus } from "../../types/v1/status_pb";
import { file_types_v1_status } from "../../types/v1/status_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file external/v1/model.proto.
 */
export const file_external_v1_model: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_google_protobuf_timestamp, file_google_type_date, file_google_type_decimal, file_types_v1_area, file_types_v1_deal, file_types_v1_status]);

/**
 * 注文
 *
 * @generated from message external.v1.Order
 */
export type Order = Message<"external.v1.Order"> & {
  /**
   * @generated from field: string platform_id = 1;
   */
  platformId: string;

  /**
   * @generated from field: types.v1.ProductSpreadType product_spread_type = 6;
   */
  productSpreadType: ProductSpreadType;

  /**
   * 注文内のLegを渡す 注文がスプレッドなどで複数のLegを持つ場合は、Legを分割して渡す
   *
   * @generated from field: repeated external.v1.Leg legs = 7;
   */
  legs: Leg[];

  /**
   * 注文日時
   *
   * @generated from field: google.protobuf.Timestamp order_at = 9;
   */
  orderAt?: Timestamp;
};

/**
 * Describes the message external.v1.Order.
 * Use `create(OrderSchema)` to create a new message.
 */
export const OrderSchema: GenMessage<Order> = /*@__PURE__*/
  messageDesc(file_external_v1_model, 0);

/**
 * 約定時の情報
 *
 * @generated from message external.v1.Deal
 */
export type Deal = Message<"external.v1.Deal"> & {
  /**
   * @generated from field: string platform_id = 1;
   */
  platformId: string;

  /**
   * @generated from field: string platform_deal_id = 2;
   */
  platformDealId: string;

  /**
   * @generated from field: string platform_deal_code = 3;
   */
  platformDealCode: string;

  /**
   * @generated from field: repeated external.v1.Leg legs = 4;
   */
  legs: Leg[];

  /**
   * @generated from field: types.v1.ProductSpreadType product_spread_type = 5;
   */
  productSpreadType: ProductSpreadType;

  /**
   * 約定日時
   *
   * @generated from field: google.protobuf.Timestamp dealt_at = 6;
   */
  dealtAt?: Timestamp;

  /**
   * 約定価格
   *
   * @generated from field: google.type.Decimal unit_price_per_kwh = 7;
   */
  unitPricePerKwh?: Decimal;

  /**
   * 約定に関わる当事者の詳細情報 (約定時に再計算されるため受け取らない
   *
   * @generated from field: repeated external.v1.DealPartyDetail deal_party_details = 8;
   */
  dealPartyDetails: DealPartyDetail[];

  /**
   * @generated from field: optional string created_by_id = 9;
   */
  createdById?: string;

  /**
   * @generated from field: optional string updated_by_id = 10;
   */
  updatedById?: string;

  /**
   * @generated from field: optional external.v1.EClearPosting eclear_posting = 11;
   */
  eclearPosting?: EClearPosting;

  /**
   * eClear成約ID
   *
   * @generated from field: string eclear_deal_code = 12;
   */
  eclearDealCode: string;

  /**
   * 取引持込元区分
   *
   * @generated from field: optional types.v1.DealSubmissionSource deal_submission_source = 13;
   */
  dealSubmissionSource?: DealSubmissionSource;

  /**
   * Deal-level clearer (StoneX/KGI). Sourced from EEXPostingInfo.Clearer when posting exists, falling back to physical-side organization contract clearer for 現先 deals; absent for 現現 deals.
   *
   * @generated from field: optional string clearer = 14;
   */
  clearer?: string;
};

/**
 * Describes the message external.v1.Deal.
 * Use `create(DealSchema)` to create a new message.
 */
export const DealSchema: GenMessage<Deal> = /*@__PURE__*/
  messageDesc(file_external_v1_model, 1);

/**
 * @generated from message external.v1.Leg
 */
export type Leg = Message<"external.v1.Leg"> & {
  /**
   * 注文・約定内の取引を渡す 基本的に1つだが、再構築などで取引が1:1でない場合は、複数のTransactionを渡す
   *
   * @generated from field: repeated external.v1.Transaction transactions = 1;
   */
  transactions: Transaction[];

  /**
   * スプレッド区分
   *
   * @generated from field: optional types.v1.SpreadType spread_type = 3;
   */
  spreadType?: SpreadType;
};

/**
 * Describes the message external.v1.Leg.
 * Use `create(LegSchema)` to create a new message.
 */
export const LegSchema: GenMessage<Leg> = /*@__PURE__*/
  messageDesc(file_external_v1_model, 2);

/**
 * 注文・約定内の取引 注文と約定で共通の取引情報
 *
 * @generated from message external.v1.Transaction
 */
export type Transaction = Message<"external.v1.Transaction"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * 1kWhあたりの単価(円) スプレッドやLeg分割する場合は建値
   *
   * @generated from field: google.type.Decimal unit_price_per_kwh = 2;
   */
  unitPricePerKwh?: Decimal;

  /**
   * 取引量(kW) Legにより数量が異なる場合は、分解したLegの数量
   *
   * @generated from field: int64 volume_in_kw = 3 [jstype = JS_STRING];
   */
  volumeInKw: string;

  /**
   * 休日等を無視した、商品自体の受給期間の開始日時
   *
   * @generated from field: google.protobuf.Timestamp delivery_start_at = 4;
   */
  deliveryStartAt?: Timestamp;

  /**
   * 休日等を無視した、商品自体の受給期間の終了日時
   *
   * @generated from field: google.protobuf.Timestamp delivery_end_at = 5;
   */
  deliveryEndAt?: Timestamp;

  /**
   * 商品区分。BG渡し(eClear)/JEPX渡しなど
   *
   * @generated from field: types.v1.DeliveryType delivery_type = 6;
   */
  deliveryType: DeliveryType;

  /**
   * @generated from field: types.v1.DeliveryType eclear_delivery_type = 7;
   */
  eclearDeliveryType: DeliveryType;

  /**
   * 広域マスタ登録の確認用
   *
   * @generated from field: types.v1.AreaCode area_code = 8;
   */
  areaCode: AreaCode;

  /**
   * 買い/売り 区分 eClearはこの逆ポジションで取引を行う
   *
   * @generated from field: types.v1.DealPosition deal_position = 9;
   */
  dealPosition: DealPosition;

  /**
   * 時間帯区分
   *
   * @generated from field: types.v1.DeliveryHourType delivery_hour_type = 10;
   */
  deliveryHourType: DeliveryHourType;

  /**
   * Deprecated as input: リクエストでは無視される。差額精算対象エリアは入力ではなく、
   * 当事者が受渡エリアの BG を持たない場合に組織のエリア読み替え表から導出して deal に
   * 焼き込む (eposition-app #6261)。送信側は設定しないこと。
   * レスポンスでは有効で、その deal がどのエリアの JEPX スポット価格で差額精算されるかを報告する。
   * フィールド自体の撤去は pikopiko 側の対応完了後に eclear_area_code と併せて行う (eposition-app #6263)。
   *
   * @generated from field: optional types.v1.AreaCode settlement_difference_target_area_code = 11 [deprecated = true];
   * @deprecated
   */
  settlementDifferenceTargetAreaCode?: AreaCode;

  /**
   * @generated from field: types.v1.DeliveryPeriodType delivery_period_type = 12;
   */
  deliveryPeriodType: DeliveryPeriodType;

  /**
   * 月別のkWh 総量
   *
   * @generated from field: repeated external.v1.Transaction.MonthlyKWH monthly_kwh = 14;
   */
  monthlyKwh: Transaction_MonthlyKWH[];

  /**
   * 総量の計算に利用したカレンダーの種別
   *
   * @generated from field: repeated external.v1.CalendarType calendar_types = 15;
   */
  calendarTypes: CalendarType[];

  /**
   * EEXのポジション情報
   *
   * @generated from field: optional external.v1.Transaction.EEXPostingInfo eex_posting_info = 16;
   */
  eexPostingInfo?: Transaction_EEXPostingInfo;

  /**
   * 取引の当事者情報
   *
   * @generated from field: optional external.v1.Transaction.Customer customer = 17;
   */
  customer?: Transaction_Customer;

  /**
   * 注文者ID
   *
   * @generated from field: optional string orderer_id = 18;
   */
  ordererId?: string;

  /**
   * 与信ステータス
   *
   * @generated from field: external.v1.CreditStatus credit_status = 19;
   */
  creditStatus: CreditStatus;

  /**
   * Deprecated: use `floating_index.code` instead.
   *
   * @generated from field: optional string floating_index_code = 20 [deprecated = true];
   * @deprecated
   */
  floatingIndexCode?: string;

  /**
   * 変動指標。変動価格付き取引の場合に設定
   *
   * @generated from field: optional external.v1.FloatingIndex floating_index = 21;
   */
  floatingIndex?: FloatingIndex;

  /**
   * 全期間が清算完了した日時。null の場合は未清算（部分清算も含む）。
   * 設定されている場合、その transaction は MTM 評価の対象外。
   *
   * @generated from field: optional google.protobuf.Timestamp settled_at = 22;
   */
  settledAt?: Timestamp;

  /**
   * どこまで清算済みかを表す日付（月次清算の進捗）。null の場合は
   * 全期間が未清算。settled_at が null でも、settled_until 以前の
   * 月は既に清算済みなので MTM 計算からは除外する。
   *
   * @generated from field: optional google.type.Date settled_until = 23;
   */
  settledUntil?: Date;

  /**
   * 約定明細の識別子。ePosition が採番するため、約定登録のリクエストでは空で送る。
   *
   * @generated from field: string deal_transaction_id = 24;
   */
  dealTransactionId: string;

  /**
   * 特種取引フラグ。true の取引は、その取引を持つ組織のリスク計算（証拠金・MC・MTM・PFE・IM・与信チェック・各種レポートの集計値。市場リスクレポートと流動性キャッシュフローは除く）から除外される。
   * 未指定は false。
   * フラグは取引（明細）単位。同じ組織の取引どうしでフラグがそろっているかは検証しない。
   * 同じ leg の相手側の取引にフラグがある組織の備考（手数料を計算した組織の当事者明細がある場合）には、約定作成時に「特種取引です。契約相手は{組織名}です」が入る（組織名が空なら会社名）。
   * 約定登録（CreateDeal）では、現先の取引に付けた場合は InvalidArgument になる。
   * 注文（CheckOrderRisk / GetEClearFee など）では指定できない。取引種別に関係なく true を付けると InvalidArgument になる。
   * 応答（GetDeal / ListDeals）では保存されている値を返す。作成後は変更できない。
   *
   * @generated from field: optional bool is_special_trade = 25;
   */
  isSpecialTrade?: boolean;
};

/**
 * Describes the message external.v1.Transaction.
 * Use `create(TransactionSchema)` to create a new message.
 */
export const TransactionSchema: GenMessage<Transaction> = /*@__PURE__*/
  messageDesc(file_external_v1_model, 3);

/**
 * @generated from message external.v1.Transaction.Customer
 */
export type Transaction_Customer = Message<"external.v1.Transaction.Customer"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string phone_number = 2;
   */
  phoneNumber: string;

  /**
   * @generated from field: string email = 3;
   */
  email: string;
};

/**
 * Describes the message external.v1.Transaction.Customer.
 * Use `create(Transaction_CustomerSchema)` to create a new message.
 */
export const Transaction_CustomerSchema: GenMessage<Transaction_Customer> = /*@__PURE__*/
  messageDesc(file_external_v1_model, 3, 0);

/**
 * @generated from message external.v1.Transaction.EEXPostingInfo
 */
export type Transaction_EEXPostingInfo = Message<"external.v1.Transaction.EEXPostingInfo"> & {
  /**
   * EEXのトレーダーコード
   *
   * @generated from field: string trader_code = 1;
   */
  traderCode: string;

  /**
   * EEX ポスティングID
   *
   * @generated from field: string posting_id = 2;
   */
  postingId: string;

  /**
   * EEXのクリアリング口座コード
   *
   * @generated from field: string clearing_account_code = 3;
   */
  clearingAccountCode: string;

  /**
   * EEXのプロダクトコード
   *
   * @generated from field: string product_code = 4;
   */
  productCode: string;

  /**
   * EEXのインストゥルメントコード (限月等)
   *
   * @generated from field: string instrument = 5;
   */
  instrument: string;

  /**
   * @generated from field: optional string trader_name = 6;
   */
  traderName?: string;

  /**
   * @generated from field: optional string clearing_account_name = 7;
   */
  clearingAccountName?: string;

  /**
   * Clearer (StoneX/KGI) used at posting time. Sourced from dbeposition.eex_posting.clearer.
   *
   * @generated from field: optional string clearer = 8;
   */
  clearer?: string;
};

/**
 * Describes the message external.v1.Transaction.EEXPostingInfo.
 * Use `create(Transaction_EEXPostingInfoSchema)` to create a new message.
 */
export const Transaction_EEXPostingInfoSchema: GenMessage<Transaction_EEXPostingInfo> = /*@__PURE__*/
  messageDesc(file_external_v1_model, 3, 1);

/**
 * 受給期間 内の月別kWh
 *
 * @generated from message external.v1.Transaction.MonthlyKWH
 */
export type Transaction_MonthlyKWH = Message<"external.v1.Transaction.MonthlyKWH"> & {
  /**
   * @generated from field: uint32 year = 1;
   */
  year: number;

  /**
   * @generated from field: uint32 month = 2;
   */
  month: number;

  /**
   * @generated from field: google.type.Decimal kwh = 3;
   */
  kwh?: Decimal;
};

/**
 * Describes the message external.v1.Transaction.MonthlyKWH.
 * Use `create(Transaction_MonthlyKWHSchema)` to create a new message.
 */
export const Transaction_MonthlyKWHSchema: GenMessage<Transaction_MonthlyKWH> = /*@__PURE__*/
  messageDesc(file_external_v1_model, 3, 2);

/**
 * 変動指標
 *
 * @generated from message external.v1.FloatingIndex
 */
export type FloatingIndex = Message<"external.v1.FloatingIndex"> & {
  /**
   * 変動指標コード (例: JERAGM_Wholesale_TBL_NEWC)
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * 燃調計算式
   *
   * @generated from field: string formula = 2;
   */
  formula: string;
};

/**
 * Describes the message external.v1.FloatingIndex.
 * Use `create(FloatingIndexSchema)` to create a new message.
 */
export const FloatingIndexSchema: GenMessage<FloatingIndex> = /*@__PURE__*/
  messageDesc(file_external_v1_model, 4);

/**
 * @generated from message external.v1.DealPartyDetail
 */
export type DealPartyDetail = Message<"external.v1.DealPartyDetail"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * eClear基本手数料(円/kWh)
   *
   * @generated from field: google.type.Decimal eclear_fee_rate = 2;
   */
  eclearFeeRate?: Decimal;

  /**
   * 金利コスト(円/kWh)
   *
   * @generated from field: google.type.Decimal interest_charge = 3;
   */
  interestCharge?: Decimal;

  /**
   * 備考
   *
   * @generated from field: string remarks = 4;
   */
  remarks: string;

  /**
   * スプレッドの交換側の脚に掛ける eClear 手数料（円/kWh）。0 より大きいとき交換側に請求がある。それ以外は 0
   * 応答だけで使う。CreateDeal の入力（deal_party_details）に入れても読まない
   *
   * @generated from field: optional google.type.Decimal exchange_eclear_fee_rate = 5;
   */
  exchangeEclearFeeRate?: Decimal;
};

/**
 * Describes the message external.v1.DealPartyDetail.
 * Use `create(DealPartyDetailSchema)` to create a new message.
 */
export const DealPartyDetailSchema: GenMessage<DealPartyDetail> = /*@__PURE__*/
  messageDesc(file_external_v1_model, 5);

/**
 * @generated from message external.v1.EClearFee
 */
export type EClearFee = Message<"external.v1.EClearFee"> & {
  /**
   * eClear手数料(円/kWh) eClear基本手数料と金利コストを合算して返却する
   *
   * @generated from field: google.type.Decimal fee_per_kwh = 1;
   */
  feePerKwh?: Decimal;
};

/**
 * Describes the message external.v1.EClearFee.
 * Use `create(EClearFeeSchema)` to create a new message.
 */
export const EClearFeeSchema: GenMessage<EClearFee> = /*@__PURE__*/
  messageDesc(file_external_v1_model, 6);

/**
 * @generated from message external.v1.EClearPosting
 */
export type EClearPosting = Message<"external.v1.EClearPosting"> & {
  /**
   * @generated from field: types.v1.EClearPostingStatus status = 1;
   */
  status: EClearPostingStatus;

  /**
   * ポスティング完了日時
   *
   * @generated from field: google.protobuf.Timestamp completed_at = 2;
   */
  completedAt?: Timestamp;
};

/**
 * Describes the message external.v1.EClearPosting.
 * Use `create(EClearPostingSchema)` to create a new message.
 */
export const EClearPostingSchema: GenMessage<EClearPosting> = /*@__PURE__*/
  messageDesc(file_external_v1_model, 7);

/**
 * 約定毎の清算情報
 *
 * @generated from message external.v1.DealSettles
 */
export type DealSettles = Message<"external.v1.DealSettles"> & {
  /**
   * @generated from field: string platform_deal_id = 1;
   */
  platformDealId: string;

  /**
   * @generated from field: repeated external.v1.DealTransactionSettle transaction_settles = 2;
   */
  transactionSettles: DealTransactionSettle[];

  /**
   * どこまで清算済みかを表す日付（全取引の最も新しいTransactionのsettled_atを参照）
   *
   * @generated from field: optional google.protobuf.Timestamp settled_until = 3;
   */
  settledUntil?: Timestamp;

  /**
   * 全ての取引が清算済みかどうか
   *
   * @generated from field: bool is_settled = 4;
   */
  isSettled: boolean;
};

/**
 * Describes the message external.v1.DealSettles.
 * Use `create(DealSettlesSchema)` to create a new message.
 */
export const DealSettlesSchema: GenMessage<DealSettles> = /*@__PURE__*/
  messageDesc(file_external_v1_model, 8);

/**
 * 約定取引清算情報
 *
 * @generated from message external.v1.DealTransactionSettle
 */
export type DealTransactionSettle = Message<"external.v1.DealTransactionSettle"> & {
  /**
   * @generated from field: string deal_transaction_settle_id = 1;
   */
  dealTransactionSettleId: string;

  /**
   * @generated from field: string deal_transaction_id = 2;
   */
  dealTransactionId: string;

  /**
   * 受給開始日
   *
   * @generated from field: google.protobuf.Timestamp delivery_start_date = 3;
   */
  deliveryStartDate?: Timestamp;

  /**
   * 受給終了日
   *
   * @generated from field: google.protobuf.Timestamp delivery_end_date = 4;
   */
  deliveryEndDate?: Timestamp;

  /**
   * 清算完了日 (nullの場合は未清算)
   *
   * @generated from field: optional google.protobuf.Timestamp settled_at = 5;
   */
  settledAt?: Timestamp;
};

/**
 * Describes the message external.v1.DealTransactionSettle.
 * Use `create(DealTransactionSettleSchema)` to create a new message.
 */
export const DealTransactionSettleSchema: GenMessage<DealTransactionSettle> = /*@__PURE__*/
  messageDesc(file_external_v1_model, 9);

/**
 * @generated from enum external.v1.CalendarType
 */
export enum CalendarType {
  /**
   * @generated from enum value: CALENDAR_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 北海道
   *
   * @generated from enum value: CALENDAR_TYPE_HOKKAIDO = 1;
   */
  HOKKAIDO = 1,

  /**
   * 東北
   *
   * @generated from enum value: CALENDAR_TYPE_TOHOKU = 2;
   */
  TOHOKU = 2,

  /**
   * 東京
   *
   * @generated from enum value: CALENDAR_TYPE_TOKYO = 3;
   */
  TOKYO = 3,

  /**
   * 中部
   *
   * @generated from enum value: CALENDAR_TYPE_CHUBU = 4;
   */
  CHUBU = 4,

  /**
   * 北陸
   *
   * @generated from enum value: CALENDAR_TYPE_HOKURIKU = 5;
   */
  HOKURIKU = 5,

  /**
   * 関西
   *
   * @generated from enum value: CALENDAR_TYPE_KANSAI = 6;
   */
  KANSAI = 6,

  /**
   * 中国
   *
   * @generated from enum value: CALENDAR_TYPE_CHUGOKU = 7;
   */
  CHUGOKU = 7,

  /**
   * 四国
   *
   * @generated from enum value: CALENDAR_TYPE_SHIKOKU = 8;
   */
  SHIKOKU = 8,

  /**
   * 九州
   *
   * @generated from enum value: CALENDAR_TYPE_KYUSHU = 9;
   */
  KYUSHU = 9,

  /**
   * EEX
   *
   * @generated from enum value: CALENDAR_TYPE_EEX = 10;
   */
  EEX = 10,
}

/**
 * Describes the enum external.v1.CalendarType.
 */
export const CalendarTypeSchema: GenEnum<CalendarType> = /*@__PURE__*/
  enumDesc(file_external_v1_model, 0);

/**
 * 与信ステータス
 *
 * @generated from enum external.v1.CreditStatus
 */
export enum CreditStatus {
  /**
   * @generated from enum value: CREDIT_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 与信OK
   *
   * @generated from enum value: CREDIT_STATUS_APPROVED = 1;
   */
  APPROVED = 1,

  /**
   * 与信NG
   *
   * @generated from enum value: CREDIT_STATUS_REJECTED = 2;
   */
  REJECTED = 2,
}

/**
 * Describes the enum external.v1.CreditStatus.
 */
export const CreditStatusSchema: GenEnum<CreditStatus> = /*@__PURE__*/
  enumDesc(file_external_v1_model, 1);

